import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useLangStore = defineStore('lang', () => {
  const locale = ref(localStorage.getItem('tfcenter-locale') || 'zh-cn')

  watch(locale, (val) => {
    localStorage.setItem('tfcenter-locale', val)
  })

  const setLocale = (lang) => {
    locale.value = lang
  }

  return { locale, setLocale }
})
